module.exports = __webpack_public_path__ + "assets/img/teacher (62).763d5156.png";